import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { INotification } from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  protected http = inject(HttpClient);

  getNotifications() {
    return this.http
      .get<{ data: INotification[] }>('/notifications')
      .pipe(map((response) => response.data));
  }

  getNotificationsUnreadCount() {
    return this.http
      .get<{ data: number }>('/notifications/unread-count')
      .pipe(map((response) => response.data));
  }

  markNotificationAsRead(notification: INotification) {
    return this.http
      .post<{ data: INotification }>(
        `/notifications/${notification.type}/${notification.id}/mark-as-read`,
        {},
      )
      .pipe(map((response) => response.data));
  }
}
